const main = () => {
    const items = document.querySelectorAll('[data-toggle-item]');
    if (items.length === 0) return;

    items.forEach(item => {
        const trigger = item.querySelector('[data-toggle-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
            item.toggleAttribute('data-active');
        });
    });
}

export default main
